import {Box, keyframes} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";

export default function AiButtonUI({onClick}: {onClick: () => void}) {
  const rotateAnimation = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  `;

  const shapeShiftAnimation = keyframes`
    0% {
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
      border-radius: 8px;
    }
    50% {
      clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
      border-radius: 16px;
    }
    100% {
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
      border-radius: 8px;
    }
  `;

  return (
    <Box sx={{width: "24px", height: "24px", overflow: "visible"}}>
      <Box
        onClick={onClick}
        sx={{
          transform: "translate(-17.5%, -17.5%)",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#76acff",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            width: "85%",
            height: "85%",
            top: "7.5%",
            left: "7.5%",
            backgroundColor: "transparent",
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            transition: "background-color 0.3s ease",
            zIndex: -1,
            borderRadius: "8px",
          },
          "&:hover": {
            color: "white",
            cursor: "pointer",
          },
          "&:hover::before": {
            backgroundColor: "#76acff",
            animation: `${rotateAnimation} 4s linear infinite, ${shapeShiftAnimation} 4s ease-in-out infinite`,
          },
          "& > span": {
            transition: "transform 1s ease, font-size 0.3s ease",
            transformOrigin: "center",
            display: "flex",
            zIndex: 1,
            fontSize: "32px",
          },
          "&:hover > span": {
            transform: "rotate(180deg)",
            fontSize: "24px",
          },
        }}>
        <MaterialSymbol icon="stat_0" fill />
      </Box>
    </Box>
  );
}
